import { render, staticRenderFns } from "./LeonidaStampeComponent.vue?vue&type=template&id=e617cfa0"
import script from "./LeonidaStampeComponent.vue?vue&type=script&lang=js"
export * from "./LeonidaStampeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports